<template>
  <div class="developer-recommendation">
    <h3 class="developer-recommendation__title">
      <span>Recommendation</span>
      <v-btn
        class="developer-recommendation__edit-btn"
        outlined
        fab
        tile
        x-small
        color="blue"
        @click="showRecommendationModal"
      >
        <v-icon dark>mdi-square-edit-outline</v-icon>
      </v-btn>
    </h3>

    <div class="developer-recommendation__content">
      <div v-if="score" class="developer-recommendation__score-track">
        <div
          class="developer-recommendation__score-bar"
          :style="{ 'height': `${score}%` }"
        >
          <div
            :class="{ 'developer-recommendation__score-rate--low': score < 30 }"
            class="developer-recommendation__score-rate">{{ score }}%</div>
        </div>
      </div>
      <div
        v-if="developer.recommendation && developer.recommendation.length"
        class="developer-recommendation__text"
      >
        {{ developer.recommendation }}
      </div>
      <EmptyState
        v-else
        outlined
        title="Would you like to add recommendation?"
        description="Recommendation will be visible in the CV."
        @click="showRecommendationModal"
      />
      <div class="clear-both"></div>
    </div>

    <RecommendationModal v-model="isRecommendationModalVisible" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EmptyState from '@/components/Developers/Show/EmptyState.vue';
import RecommendationModal from '@/components/Developers/Show/RecommendationModal.vue';

export default {
  components: {
    EmptyState,
    RecommendationModal,
  },

  props: {
    score: {
      type: Number,
      required: false,
      default: undefined,
    },
  },

  data() {
    return {
      isRecommendationModalVisible: false,
    };
  },

  computed: {
    ...mapState('hrDeveloper', [
      'developer',
    ]),
  },

  methods: {
    showRecommendationModal() {
      this.isRecommendationModalVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.developer-recommendation {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;

  &:hover .developer-recommendation__edit-btn {
    opacity: 1;
  }

  &__title {
    color: $main--headers;
    font-size: 18px;
    line-height: 21px;
    font-weight: 500;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__edit-btn {
    border-radius: 4px;
    border-color: $color--secondary;
    opacity: 0;
    transition: all 0.4s ease;
  }

  &__content {
    letter-spacing: 0;
    color: rgba(57,70,87,0.7);
    margin-bottom: 4px;
    font-weight: 300;
  }

  &__text {
    float: none;
  }

  &__score-track {
    height: 150px;
    width: 40px;
    margin-right: 24px;
    margin-bottom: 12px;
    background: #E2E6EA;
    position: relative;
    float: left;
  }
  &__score-bar {
    background: #6C7BE6;
    width: 100%;
    // height: 70%;
    position: absolute;
    bottom: 0;
    display: flex;
    align-self: center;
    justify-content: center;
    flex-direction: column;
  }
  &__score-rate {
    color: white;
    text-align: center;
    font-size: 14px;
    font-weight: 500;

    &--low {
      width: 100%;
      position: absolute;
      text-align: center;
      top: -20px;
      color: black;
    }
  }
}
</style>
